import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import useSearchParams from 'modules/core/hooks/useSearchParams'
import i18n from 'modules/core/lib/i18n'

interface Params {
  createdRoleId: number
}

const RoleCreatedModalPage: React.FC = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const params = useSearchParams<Params>()

  const footer = (
    <>
      <Button.Router
        type="secondary"
        disabled={!params.createdRoleId}
        to={`${navigation.employees.jobCatalog.role.settings.fullPath({
          id: params.createdRoleId,
        })}?goToRole=true`}
      >
        {i18n.t('teams.role_created_modal.go_to_settings')}
      </Button.Router>
      <Button type="primary" onClick={() => navigate(-2)}>
        {i18n.t('teams.role_created_modal.stay_in_teams')}
      </Button>
    </>
  )

  return (
    <Modal
      illustration="check"
      title={i18n.t('teams.role_created_modal.title')}
      description={i18n.t('teams.role_created_modal.description')}
      footer={footer}
    />
  )
}

export default RoleCreatedModalPage
